import Translate from "src/components/Translate";
import translate from "src/functions/translate";

function getFilterSelectorTranslation(origTitle: any, lang: any) {
  const origTitleValue =
    origTitle.props === undefined ? origTitle : origTitle.props?.tKey;
  const title = translate(origTitleValue.replace(/_/g, ` `), lang);
  const firstWord = title?.substring(0, title.indexOf(" "));
  const restWords = title?.substring(title.indexOf(" ") + 1);

  let multiWordTitle = "";
  if (
    firstWord === "being" ||
    firstWord === "body" ||
    firstWord === "mind" ||
    firstWord === "soul" ||
    firstWord === "technique" ||
    firstWord === "vitality"
  ) {
    multiWordTitle = `${firstWord}: ${restWords}`;
  }

  return multiWordTitle === "" ? (
    title === undefined ? (
      origTitle
    ) : (
      title
    )
  ) : (
    <Translate tKey={multiWordTitle} />
  );
}

export default getFilterSelectorTranslation;
